import { render, staticRenderFns } from "./ViewHousesTable.vue?vue&type=template&id=740d890d"
import script from "./ViewHousesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewHousesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports